import { Component, Prop, State, h } from "@stencil/core";
import ChatSDK from 'test-iso-chat-sdk';
import '../../stories/Components/BlockUsers/BlockUsers';
import {drawerDialogService} from '../../stories/Components/Dialog-Drawer/dialog-drawer.js'

@Component({
  tag: 'block-chat-list',
  shadow: true,
  styles: `
  :host{
    height:96%;
  }
  `,
})
export class BlockChatList {
  @Prop() goBack: () => void;
  @State() blockUsers: any = [];
  @State() isLoading: boolean = false;
  @State() skip: number = 0;
  @State() hasMore: boolean = false;
  @State() paginationLoading: boolean = false;

  async componentWillLoad() {
    await this.findBlokedUser(); 
  }

  findBlokedUser = async (searchTag?: string, skip: number = 0) => {
    if (skip === 0) {
        this.isLoading = true;
        this.blockUsers = [];
    }

    if (skip >= 20) {
        this.paginationLoading = true;
    }

    this.hasMore = true;

    try {
        let payload = {
            limit: 20,
            skip: skip,
        };

        if (searchTag) {
            payload['searchTag'] = searchTag;
        }

        const findRes = await ChatSDK.getInstance().user.getUserBlock(payload);

        if (findRes?.users) {
            if (skip === 0) {
                this.blockUsers = [...findRes.users];
            } else {
                this.blockUsers = [...this.blockUsers, ...findRes.users];
            }
        }

        if (findRes?.users?.length < payload.limit) {
            this.hasMore = false;
        }
    } catch (error) {
        if (error?.status === 404 || error?.statusCode === 404) {
            this.hasMore = false;
        }
        if ((error?.status === 404 || error?.statusCode === 404) && searchTag != null) {
            this.blockUsers = [];
        }
        console.error(error);
    } finally {
        this.isLoading = false;
        this.paginationLoading = false;
    }
  }

  handleUnblockUser = async (conversationId: string) => {
    this.isLoading = true;
    try {
      await ChatSDK.getInstance().user.postUserUnblock({
        opponentId: conversationId,
      });
      this.blockUsers = this.blockUsers?.filter((user) => user.userId !== conversationId);
    } catch (error) {
      console.error(`Failed to unblock user with ID ${conversationId}:`, error);
    } finally {
      this.isLoading = false;
    drawerDialogService.closeDialog('confirm-dialog')
    }
  };

  render() {
    return (
      <blocked-users-list
          blockedUsers={this.blockUsers}
          isLoading={this.isLoading}
          handleUnblock={this.handleUnblockUser}
          goBack={() => this.goBack()}
          findBlokedUser={this.findBlokedUser}
          skip={this.skip}
          hasMore={this.hasMore}
          paginationLoading={this.paginationLoading}
      >
      </blocked-users-list>
    )
  }
}